/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const LineItemTypeEnum = {
    PreVat: 'pre_vat',
    PostVat: 'post_vat',
    GridFees: 'grid_fees'
};
/**
 * Check if a given object implements the LineItem interface.
 */
export function instanceOfLineItem(value) {
    if (!('invoiceLineItemId' in value) || value['invoiceLineItemId'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('unit' in value) || value['unit'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    if (!('totalCost' in value) || value['totalCost'] === undefined)
        return false;
    return true;
}
export function LineItemFromJSON(json) {
    return LineItemFromJSONTyped(json, false);
}
export function LineItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'invoiceLineItemId': json['invoice_line_item_id'],
        'name': json['name'],
        'type': json['type'],
        'unit': json['unit'],
        'quantity': json['quantity'],
        'price': json['price'],
        'totalCost': json['total_cost'],
    };
}
export function LineItemToJSON(json) {
    return LineItemToJSONTyped(json, false);
}
export function LineItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'invoice_line_item_id': value['invoiceLineItemId'],
        'name': value['name'],
        'type': value['type'],
        'unit': value['unit'],
        'quantity': value['quantity'],
        'price': value['price'],
        'total_cost': value['totalCost'],
    };
}
